<script setup lang="ts">
/** Tag section of the list's filter menu (inside ConversationList's channel dropdown <ul>). */
import { useCollab } from '../../stores/collab'
import { useInbox } from '../../stores/inbox'
import Icon from '../ui/Icon.vue'

const emit = defineEmits<{ picked: [] }>()
const collab = useCollab()
const inbox = useInbox()

function pick(id: string | null): void {
  inbox.setTagFilter(id)
  emit('picked')
}
</script>

<template>
  <template v-if="collab.tagDefs.length">
    <li class="tf-sep" role="separator"></li>
    <li class="tf-h" role="presentation">กรองตามแท็กลูกค้า</li>
    <li>
      <button role="option" :aria-selected="inbox.tagFilter === null" class="dd-opt tf-opt" @click="pick(null)">
        <span>ทุกแท็ก</span>
        <Icon v-if="inbox.tagFilter === null" name="check" />
      </button>
    </li>
    <li v-for="t in collab.tagDefs" :key="t.id">
      <button role="option" :aria-selected="inbox.tagFilter === t.id" class="dd-opt tf-opt" @click="pick(t.id)">
        <span class="tf-l"><span class="tone-dot" :class="'td-' + t.tone"></span>{{ t.name }}</span>
        <Icon v-if="inbox.tagFilter === t.id" name="check" />
      </button>
    </li>
  </template>
</template>

<style scoped>
.tf-sep {
  height: 1px;
  margin: 4px 6px;
  background: var(--line);
}
.tf-h {
  padding: 4px 10px 2px;
  font-size: 12px;
  line-height: 18px;
  color: var(--mut);
  white-space: nowrap;
}
/* same look as ConversationList's .dd-opt (its scoped style does not reach this component) */
.tf-opt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border-radius: 7px;
  font-size: 13px;
  line-height: 20px;
  white-space: nowrap;
}
.tf-opt:hover {
  background: #f4f6f5;
}
.tf-opt[aria-selected='true'] {
  color: var(--ac2);
  font-weight: 600;
}
.tf-opt :deep(.ic) {
  width: 15px;
  height: 15px;
}
.tf-l {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
</style>
